import * as React from "react"
import { useState } from "react"
import { Avatar, Box, Chip, Collapse, Paper, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import ProductRow from "./ProductRow"


export default function DuplicateGroup({ group }) {
    const { sku } = group
    // Collapsed by default so a page of groups reads as a list of SKUs
    const [isOpen, setIsOpen] = useState(false)

    return <Paper variant="outlined" sx={{ mb: 2, overflow: 'hidden' }}>
        <Box
            role="button"
            aria-expanded={isOpen}
            onClick={() => setIsOpen(open => !open)}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 1.5,
                backgroundColor: '#f0fdf4',
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': { backgroundColor: '#dcfce7' }
            }}
        >
            <Avatar
                src={sku.image}
                variant="rounded"
                sx={{ width: 72, height: 72, bgcolor: '#fff', border: '1px solid #d1fae5', '& img': { objectFit: 'contain' } }}
            >
                <IconSeeker icon="box" sx={{ color: '#9ca3af' }} />
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body1" sx={{ fontWeight: 600, color: '#065f46' }} noWrap title={sku.name || ''}>
                    {sku.name || `SKU ${sku.id_sku}`}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    {[sku.brand, sku.reference && `Ref: ${sku.reference}`, sku.ean && `EAN: ${sku.ean}`].filter(Boolean).join(' · ')}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                    SKU ID: {sku.id_sku}
                </Typography>
            </Box>
            <Chip
                label={`${group.n_products} products`}
                size="small"
                color="warning"
                icon={<IconSeeker icon="clone" sx={{ fontSize: 12 }} />}
                sx={{ fontWeight: 600 }}
            />
            <IconSeeker
                icon="chevron-down"
                sx={{ color: '#065f46', transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'none' }}
            />
        </Box>

        <Collapse in={isOpen} unmountOnExit>
            {group.products.map(product => (
                <ProductRow key={product.product_id} group={group} product={product} />
            ))}
        </Collapse>
    </Paper>
}
